<template>
    <div class="previewComponent">
        <div id="canvasArea">
            <div class="pages_stock pages">
                <div class="page">
                    <div class="page_blocks_container">
                        <img class="page_image" v-bind:src="this.stock.product_image"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props : ['stock']
    }
</script>
<style scoped>
        .previewComponent .page_image{
        width:100%;
        height:100%;
    }
.page_blocks_container{
    width: 100%;
    height: 100%;
}
.previewComponent .page_image img{
    max-height:100%;
}
   </style>


// WEBPACK FOOTER //
// src/components/Previewstock.vue